import trackSkillChanges from '../helpers/trackSkillChanges'
//----------------------
// process delete skill
//----------------------
export default function processDeleteSkill({
  skill,
  character,
  changed_skills = [],
  original_skills = [],
}) {
  console.log('--------------------------------')
  console.log('IN processDeleteSkill')
  //------------------------------------------
  // build new array excluding deletion skill
  //------------------------------------------
  const newSkills = character.skills.filter((s) => s.id !== skill.id)
  //------------------
  // assign new array
  //------------------
  character.skills = newSkills
  //--------------------------------------------------------------------------------------
  // remove any skill adjs for deleted skill (where runecasting skill - use display_name)
  //--------------------------------------------------------------------------------------
  console.log('tttt removing skill adjs for skill = ', skill)
  console.log('uuuu skill adjs = ', character.skill_adjs)
  character.skill_adjs = character.skill_adjs.filter((adj) => skill.display_name !== '' ? adj.rune !== skill.display_name : adj.name !== skill.name)
  console.log('vvvv skill adjs = ', character.skill_adjs)
  //---------------------------------
  // track changes (record deletion)
  //---------------------------------
  const updated_changed_skills = trackSkillChanges({
    skill,
    original_skills: original_skills,
    changed_skills: changed_skills,
    delete: true, // used to remove entry from changed_skills where is new local skill (not written to db yet)
  })
  //---------
  // returns
  //---------
  return { character, updated_changed_skills }
}
